import { FootballMatchDetail } from "../../../commons/models/football/football-match-detail";
import { AbstractBaseService } from "../../../ensue-react-system/utilities/base-service";

export class ManageMatchesService extends AbstractBaseService<FootballMatchDetail> {
  protected __model: FootballMatchDetail = new FootballMatchDetail();

  public getResourceName(): string {
    return "manage/football/matches";
  }
}
